module.exports = __webpack_public_path__ + "assets/font/MiSans-Bold-8aa034b4.woff2";